/**
 * ConfettiEffect.jsx
 * Animated confetti effect for celebrations (New Year, etc.)
 */
import React, { useEffect, useState } from 'react';

const ConfettiEffect = ({ intensity = 'medium', enabled = true }) => {
  const [confetti, setConfetti] = useState([]);

  const intensityConfig = {
    light: 30,
    medium: 60,
    heavy: 100
  };

  const colors = [
    '#FFD700', // Gold
    '#FF6B6B', // Red
    '#4ECDC4', // Teal
    '#45B7D1', // Blue
    '#96CEB4', // Green
    '#FFEAA7', // Yellow
    '#DDA0DD', // Plum
    '#FF69B4', // Pink
  ];

  const count = intensityConfig[intensity] || intensityConfig.medium;

  useEffect(() => {
    if (!enabled) {
      setConfetti([]);
      return;
    }

    const pieces = Array.from({ length: count }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      color: colors[Math.floor(Math.random() * colors.length)],
      animationDuration: Math.random() * 3 + 4,
      animationDelay: Math.random() * 5,
      size: Math.random() * 8 + 4,
      rotation: Math.random() * 360,
      shape: Math.random() > 0.5 ? 'square' : 'rectangle'
    }));

    setConfetti(pieces);
  }, [enabled, intensity, count]);

  if (!enabled) return null;

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-[1]">
      <style>{`
        @keyframes confettiFall {
          0% {
            transform: translateY(-20px) rotate(0deg) scale(1);
            opacity: 1;
          }
          25% {
            transform: translateY(25vh) rotate(180deg) translateX(20px) scale(0.9);
          }
          50% {
            transform: translateY(50vh) rotate(360deg) translateX(-15px) scale(0.8);
          }
          75% {
            transform: translateY(75vh) rotate(540deg) translateX(10px) scale(0.7);
          }
          100% {
            transform: translateY(100vh) rotate(720deg) translateX(0) scale(0.5);
            opacity: 0;
          }
        }
        
        .confetti-piece {
          position: absolute;
          top: -20px;
          animation: confettiFall ease-out infinite;
        }
      `}</style>
      
      {confetti.map(piece => (
        <div
          key={piece.id}
          className="confetti-piece"
          style={{
            left: `${piece.left}%`,
            width: piece.shape === 'square' ? `${piece.size}px` : `${piece.size * 0.6}px`,
            height: `${piece.size}px`,
            backgroundColor: piece.color,
            borderRadius: '2px',
            animationDuration: `${piece.animationDuration}s`,
            animationDelay: `${piece.animationDelay}s`,
            transform: `rotate(${piece.rotation}deg)`
          }}
        />
      ))}
    </div>
  );
};

export default ConfettiEffect;
